module.exports = __webpack_public_path__ + "img/preview-13.20eff091.png";